import VueI18n from 'vue-i18n';

export function dateRangePickerLocale($i18n: VueI18n): unknown {
  return $i18n.locale === 'de'
    ? {
      direction: 'ltr',
      format: $i18n.t('dateFormatString'),
      separator: ' - ',
      applyLabel: $i18n.t('general.apply'),
      cancelLabel: $i18n.t('btnCancel'),
      weekLabel: 'W',
      customRangeLabel: 'Custom Range',
      daysOfWeek: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      monthNames: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      firstDay: 1,
    } : {
      direction: 'ltr',
      format: $i18n.t('dateFormatString'),
      separator: ' - ',
      applyLabel: $i18n.t('general.apply'),
      cancelLabel: $i18n.t('btnCancel'),
      weekLabel: 'W',
      customRangeLabel: 'Custom Range',
      daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      firstDay: 1,
    };
};